module.exports = __webpack_public_path__ + "img/sharing.e59c4a0a.svg";